module.exports = __webpack_public_path__ + "static/assets/6a1993d622119efd95ebfe197c459fd6.png";